import type { FaireProductEntity } from "../../entity_types/product";

export const p_n9q359uxe9: FaireProductEntity = {
  token: "p_n9q359uxe9",
  type: "product",
  name: "Mushroom Dungarees",
  brandToken: "b_2y1von4s08",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/573f978e9ebf9f2118b2e21c792031dce168cc7a06e275240d009fc58da02e07.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/635f667b22cecb1b9b66717689a7228d338da150fc92a869669871854f27b91d.jpeg",
    "https://cdn.faire.com/fastly/f51261f609a3c2bb534eaa7ecff939161790088d2cdc42e68aab11ca759f3c9d.jpeg",
    "https://cdn.faire.com/fastly/bffd291696622d6107b4c279599c0d2ea9af0b6020e6338cbb834b8922d2bc39.jpeg",
    "https://cdn.faire.com/fastly/72113a8adc86fb5b032fa47de26b04750de4604c392c45edc57b2c5dc2dfe1c4.jpeg",
    "https://cdn.faire.com/fastly/ac88f4fe238f3b16950d7ed327a9835fbe3627f2fd828ec0b6331a3de46ff2c5.jpeg",
    "https://cdn.faire.com/fastly/4376301c7e7d68919f5349b9b55ee09b2cf61d19a508b149147a528c78a8caf1.jpeg",
    "https://cdn.faire.com/fastly/602f79c535af64a39c797265083bdee5be65d8578c87854fac343c3a6734243e.jpeg",
    "https://cdn.faire.com/fastly/3832d54f70750cd3fa8400d7607738b8bb7aaa7b69effeb3ce163704662255be.jpeg",
    "https://cdn.faire.com/fastly/803532a3ebbe8426af009006268df554a30a82956c660f5843e96c63aa039b6c.jpeg",
  ],
  priceDollars: 30.72,
  description:
    "Mushroom print straight-leg dungarees in khaki or maroon options. Durable and comfortable to wear in strong and naturally breathable cotton with a front straight-edged bib and a pouch pocket. Three securing round coconut wood buttons on each side matched by three buttons on each shoulder strap for adjustment. The straps are wider at the back. Front diagonal stitched side pockets complete the practical design. Trendy matching accessories and unisex separates are available.\n\n100% Cotton\n\nUnisex Fit. Introducing a new range of boho clothing and complementary accessories in stunning colours, fashionable prints and flattering lines. Skilled artisans employ intensive methods such as block printing, hand screen printing, tie dying and patchworking to achieve stylish comfort, freedom of movement and durability for working and playing hard.\n\nHandwash in cold water. Warm iron.",
  tags: [],
  msrpDollars: 61.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:07.820Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
